import React from "react";
import { ListItem , Box , Card } from "arkh";


import { OrgButton } from "../OrgHome/OrgButton";

export function ArchivedCard(props: {
  title: React.ReactNode;
  onPress?: () => void;
  loading: boolean;
  unarchiveTitle: string;
}) {
  return (
    <Card>
      <Box
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <ListItem.Title>{props.title}</ListItem.Title>
        {props.onPress ? (
          <Box
            spaceLeft="medium"
            style={{ justifyContent: "flex-start", flexDirection: "row" }}
          >
            <OrgButton
              title={props.unarchiveTitle}
              backgroundColor="surface-background"
              tintColor="text-primary"
              loading={props.loading}
              onPress={props.onPress}
            />
          </Box>
        ) : null}
      </Box>
    </Card>
  );
}
